import React,{useState,useEffect} from "react";
import { useAuthUser } from "../context/authuser";
import { useParams } from "react-router-dom";
import { UserCircleIcon } from "@heroicons/react/24/outline";


function MobileInfo(){
    const {id} = useParams();
    const [user,setUser] = useState({})
    const {dbUser} = useAuthUser()
    const [load,setLoad] = useState(true)



    useEffect(() => {
        // eslint-disable-next-line array-callback-return
        const name = dbUser.filter((item) => {
            if ( id === item?.id) {
                setLoad(true)
               const data = item
               return data
            }
        })
        setUser(...name)
        setLoad(false)
    }, [dbUser, id])
    
    if(load){
        return <div className="spin"></div>
    }

 return(
        <div>
            <div className="mobile-view">
                            <h4 className="info">Profile Info</h4>
                           
                                <>
                                    <div className="profile-view">
                                    {user?.photoURL ? 
                                    <img className="view-img"  src={user?.photoURL} alt="logo"></img>
                                       : <UserCircleIcon className="view-img"/>
                                    }                                         <h4>{user?.name}</h4>
                                        <p>{user?.about}</p>
                                    </div>
                                    <div className="personal">
                                        <h2>Personal Information</h2>
                                        {user && (
                                            <div>
                                                <p className="per-info"><strong>Name :</strong> {user.name}</p>
                                                <p className="per-info"><strong>About :</strong> {user.about ? user?.about : "Set bio"}</p>
                                                <p className="per-info"><strong>Gender :</strong> {user.gender ? user.gender : "Set  Gender"}</p>
                                            </div>
                                        )}
                                        <p className="right">Copyright@2023 chat-lly Inc.All Rights Reserved</p>
                                    </div>

                                </>
                        </div>
        </div>
    )
}

export default MobileInfo;